import React from 'react';
import { useLottie } from 'lottie-react';
import { animations } from './animations';
import './index.css';

const LottieAnimation = ({
  animation = 'list',
  loop = true,
  autoplay = true,
  style = {},
  className = '',
  onComplete,
  speed = 1
}) => {
  const animationData = animations[animation]?.data || animations.list.data;

  const options = {
    animationData,
    loop,
    autoplay,
    onComplete,
    speed,
  };

  const { View } = useLottie(options);

  return (
    <div
      className={`lottie-animation ${className}`}
      data-testid="lottie-view"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...style
      }}
    >
      {View}
    </div>
  );
};

export default LottieAnimation; 